/* cv-pdp.js | Conveyor Apparel product page behaviour, redesign release 1 (REDESIGN_SPEC 4.2).
   Loaded (deferred) from sections/main-product.liquid only. No libraries, no external scripts, no timers beyond the ones named.

   What lives here
     - the size policy: data-cv-size-confirmed on <product-info> ("0" until a size is tapped), cvSizeAfterPick, cvSizeError
     - button, sticky bar and chest line kept in step with the picker after Dawn's variant refresh
     - the sticky add-to-cart bar (IntersectionObserver, no scroll listener), the size sheet, the size guide sheet
     - the Buy now button under Add to cart (guard in front of Razorpay Magic, busy state, fallback, bag note): see "Buy now" below
     - the offer tag refresh after an add (JS twin of snippets/cv-tee-count.liquid: window.cvTeeCount)
   What does NOT live here (hands-off, spec 5.2): the Style / Colour / Size picker logic and the gallery filter
   (sections/conveyor-pdp.liquid), the shadow-tee swap and window.cvAdd (snippets/cv-tee-swap.liquid), Dawn's variant refresh.

   Pixel: custom events only, through window.cvTrack (cv-core.js) when it exists, else fbq('trackCustom'). Never a standard event:
   the one real AddToCart comes from the real product form submit, whichever surface started it. */
(function () {
  'use strict';
  if (window.__cvPdpLoaded) return;
  window.__cvPdpLoaded = true;

  var doc = document;
  var pendingAdd = false;   // a submit went to Dawn and has not answered yet
  var gotUpdate = false;    // Dawn published cartUpdate for it
  var lastTap = 0;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function reduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function isPhone() { try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return window.innerWidth < 750; } }
  function info() { return $('product-info'); }
  function track(name, params) {
    try {
      if (typeof window.cvTrack === 'function') { window.cvTrack(name, params || {}); return; }
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params || {});
    } catch (e) { /* never let tracking break the page */ }
  }
  function pubsubReady() { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; }

  /* ---------- the tee rule, JS twin of snippets/cv-tee-count.liquid ----------
     A cart line counts as a tee when its product title contains "Oversized Tee". Keep the two in step. */
  if (typeof window.cvTeeCount !== 'function') {
    window.cvTeeCount = function (cart) {
      var n = 0;
      ((cart && cart.items) || []).forEach(function (it) {
        if (String(it.product_title || '').indexOf('Oversized Tee') > -1) n += +it.quantity || 0;
      });
      return n;
    };
  }

  /* ---------- reading the picker (always from the checked radios, never from input[name=id]) ---------- */
  function checkedValue(key) {
    var vs = $('variant-selects');
    if (!vs) return null;
    var nodes = vs.querySelectorAll('[data-option-name]');
    for (var i = 0; i < nodes.length; i++) {
      var on = (nodes[i].getAttribute('data-option-name') || '').toLowerCase();
      var hit = (key === 'colo') ? on.indexOf('colo') > -1 : on === key;
      if (!hit) continue;
      if (nodes[i].tagName === 'OPTION') { if (nodes[i].selected) return (nodes[i].value || '').trim(); }
      else if (nodes[i].checked) return (nodes[i].value || '').trim();
    }
    return null;
  }
  /* the size charts live once in the page, in the "Size and fit" accordion (sections/conveyor-productinfo.liquid, numbers in
     snippets/cv-size-data.liquid). kind is 'tee' or 'fleece' (Hoodie and Crewneck share one chart). Used only while final (gate G4). */
  function chart(kind) { return $('[data-cv-sizeguide] tbody[data-cv-fit="' + kind + '"]'); }
  function chartFinal(kind) { var tb = chart(kind); return !!(tb && tb.getAttribute('data-cv-final') === '1'); }
  /* the column headings after "Size", read from the chart itself: the tee chart has Chest, Shoulder, Length; the fleece chart has no Shoulder */
  function chartHeads(tb) {
    var table = tb && tb.closest ? tb.closest('table') : null;
    return table ? $$('thead th', table).slice(1).map(function (th) { return th.textContent.trim(); }) : [];
  }
  /* 'tee' or 'fleece': which chart belongs to the selected Style (or to the only garment of a design with no Style option) */
  function styleKind() {
    var s = checkedValue('style');
    if (s) return s.toLowerCase() === 'tee' ? 'tee' : 'fleece';
    return chart('tee') ? 'tee' : 'fleece';
  }
  function money(text) { return String(text || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- size policy (spec 4.2.8) ---------- */
  function confirmed() { var i = info(); return !i || i.getAttribute('data-cv-size-confirmed') !== '0'; }
  function policy() { var i = info(); return (i && i.getAttribute('data-cv-size-policy')) || 'confirm'; }
  function clearSizeError() {
    var i = info(); if (i) i.removeAttribute('data-cv-size-error');
    var er = $('[data-cv-size-err]'); if (er) er.hidden = true;
  }
  function setConfirmed(v) {
    var i = info(); if (!i) return;
    var was = i.getAttribute('data-cv-size-confirmed') === '1';
    i.setAttribute('data-cv-size-confirmed', v ? '1' : '0');
    if (v) clearSizeError();
    if (was !== !!v) refreshAll();
  }
  /* called at the end of pick() in conveyor-pdp.liquid: if the script itself changed the size (for example Tee to Hoodie while XS
     was selected), the shopper has not chosen the new one. The synthetic change event pick() dispatches never confirms. */
  window.cvSizeAfterPick = function (prev, next) {
    if (policy() === 'preselect') return;
    if (prev !== next) setConfirmed(false);
  };
  /* "Choose a size to add this.": the Size row scrolls into view and gets a 2px error outline; the line sits under it. No shake. */
  window.cvSizeError = function () {
    var i = info(); if (!i) return;
    i.setAttribute('data-cv-size-error', '1');
    var er = $('[data-cv-size-err]'); if (er) er.hidden = false;
    var fs = $('variant-selects .cv-size');
    if (fs && fs.scrollIntoView) { try { fs.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { fs.scrollIntoView(); } }
  };

  function sizeTapped(surface) {
    var now = Date.now();
    setConfirmed(true);
    if (now - lastTap > 400) track('size_chosen', { surface: surface || 'pdp' });
    lastTap = now;
  }
  /* Style pill tapped (custom event only; the value, never a price) */
  doc.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var lab = e.target.closest && e.target.closest('variant-selects .cv-style label');
    if (!lab || lab.classList.contains('cv-na')) return;
    var inp = lab.getAttribute('for') ? doc.getElementById(lab.getAttribute('for')) : null;
    if (inp && !inp.checked) track('style_pick', { style: inp.value });
  }, true);
  /* a click on a size label (a radio that is already checked fires no change), or a trusted change (arrow keys) */
  doc.addEventListener('click', function (e) {
    var lab = e.isTrusted && e.target.closest && e.target.closest('variant-selects .cv-size label, variant-selects .cv-size input[type="radio"]');
    if (lab && !lab.classList.contains('cv-na')) sizeTapped('pdp');
  }, true);
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* "Choose a size to add this." is about the garment the shopper was looking at. A new Style or Colour (tapped, or set by the
       script itself, synthetic or not) is a new choice, so the message goes; pressing add again brings it back if it still applies. */
    if (t.closest('variant-selects') && !t.closest('.cv-size')) clearSizeError();
    if (!e.isTrusted || e.cvSynthetic) return;
    if (t.closest('variant-selects')) cancelBuyPress();   /* a real pick after a Buy now press: that press no longer counts */
    if (t.closest('variant-selects .cv-size')) sizeTapped('pdp');
  }, true);

  /* the in-page button: no confirmed size, no cart request. Capture phase on document, so it runs before the product form's own
     handler (the shadow-tee swap in cv-tee-swap.liquid is a capture listener too and has already run, which is harmless). */
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
    if (!buyArming) buyGoCart = false;   /* any add the Buy now fallback did not start (Add to cart, sticky bar, size sheet) never goes on to the bag page */
    if (!confirmed()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.cvSizeError();
      return;
    }
    pendingAdd = true;
    gotUpdate = false;
  }, true);

  /* ---------- Buy now (secondary button under Add to cart, snippets/buy-buttons.liquid) ----------
     <button type="button" class="cv-buynow shopify-payment-button__button--unbranded" data-cv-buynow> sits INSIDE the product form. That
     class inside form[action="/cart/add"] is what Razorpay Magic's own script (a capture-phase click listener on document) looks for:
     it empties the bag, adds the ONE selected variant (quantity 1, this page has no quantity box) and opens Magic. So this theme code
     never talks to checkout; it only decides WHETHER Magic may take the click, and what happens if Magic does not.
       1. guard (a capture listener on WINDOW, which always runs before Magic's on document, whatever order the scripts load in):
          - disabled, sold out, unavailable, or already busy: swallow the click
          - no confirmed size: swallow it and show "Choose a size to add this." (Magic would otherwise buy the preselected size)
          - a variant refresh or an add still in flight (the hidden id is stale for a moment): swallow it, show busy, and press again
            for the shopper once the add button is ready
          - a second TRUSTED tap while the first is still opening Magic (1.5 s since the last accepted press, or, up to 20 s after it,
            Magic's own loader is up: class razorpay-magic-scroll on <html> or #magic-razorpay-spinner inside the button): swallowed.
            Without this a double tap ran Magic's whole buy flow twice (two /cart/clear.js, two /cart/add.js). The 20 s bound keeps a
            stale class (page restored from the back/forward cache) from ever disabling the button. An untrusted press (Magic's own
            fault path, or the press we release ourselves after waiting) is never swallowed here
          - a pending press belongs to the variant that was on screen when it was made: a real Style / Colour / Size pick after it
            cancels it (buyToken), so it can never fire by itself on a later pick
          - otherwise run the shadow-tee swap (merged products: Style = Tee must send the tee copy), go busy, let Magic take the click
       2. fallback (bubble listener): only reached when Magic did NOT take the click (its script blocked or not live, or its own fault
          path pressing the button again). The shopper gets the normal add to cart, then the bag page. Never a dead button.
          buyGoCart (go to the bag after the add) is armed only around the fallback's own cvAdd (buyArming); any other submit disarms it.
     Busy ends when Magic's overlay appears (a class on <html> or a node on <body>), on a 4 s floor, or when the page is shown again.
     Magic empties the bag before it adds this one item, so the note under the button (data-cv-buynow-note, server-rendered from
     cart.item_count) says so while the bag holds anything; refreshCart() keeps it in step after every cart change. */
  var buyRelease = false, buyWaiting = false, buyGoCart = false, buyArming = false, buyTimer = 0, buyToken = 0, buyPressAt = 0;
  function buyBtn() { return $('[data-cv-buynow]'); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function stopClick(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  function ensureBuyLabel(b) {
    if ($('.cv-buynow__label', b)) return;
    b.textContent = '';
    var l = doc.createElement('span'); l.className = 'cv-buynow__label'; l.textContent = 'Buy now'; b.appendChild(l);
    var bz = doc.createElement('span'); bz.className = 'cv-buynow__busy';
    bz.appendChild(doc.createTextNode('Opening')); var lo = doc.createElement('i'); lo.className = 'cvp-loader'; bz.appendChild(lo); b.appendChild(bz);
  }
  function setBuyBusy(on) {
    var b = buyBtn(); if (!b) return;
    clearTimeout(buyTimer);
    b.classList.toggle('is-busy', !!on);
    if (on) { b.setAttribute('aria-busy', 'true'); buyTimer = setTimeout(function () { setBuyBusy(false); }, 4000); }
    else { b.removeAttribute('aria-busy'); ensureBuyLabel(b); }
  }
  /* disabled exactly when the add button says sold out / unavailable; "select size" stays pressable (it shows the size error) */
  function paintBuyNow() {
    var b = buyBtn(); if (!b) return;
    var st = buttonState(), off = st === 'soldout' || st === 'unavailable';
    if (!b.classList.contains('is-busy')) ensureBuyLabel(b);
    if (b.disabled !== off) b.disabled = off;
    b.classList.toggle('is-off', off);
    if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    if (off && b.classList.contains('is-busy')) setBuyBusy(false);
  }
  function addNotReady() {
    var a = addButton();
    return !!(a && (a.disabled || a.getAttribute('aria-disabled') === 'true' || a.classList.contains('loading')));
  }
  /* settled: ready to press, or answered Sold out / Unavailable (then the guard swallows the press at once, no 4 s wait) */
  function addSettled() { var st = buttonState(); return st === 'soldout' || st === 'unavailable' || !addNotReady(); }
  function whenAddReady(cb) {
    var a = addButton(), done = false, mo = null, tm = 0;
    function fin() { if (done) return; done = true; clearTimeout(tm); if (mo) mo.disconnect(); setTimeout(cb, 60); }
    if (!a || addSettled()) { cb(); return; }
    if (window.MutationObserver) {
      mo = new MutationObserver(function () { if (addSettled()) fin(); });
      mo.observe(a, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    }
    tm = setTimeout(fin, 4000);
  }
  /* Magic's own loader or window is up: its spinner sits INSIDE the button (T(true) in magic-sopc.js) and <html> carries razorpay-magic-scroll
     until Magic closes (T(false) and S() remove them), so a tap on the button is a second tap, never a new press. Only within 20 s of
     our last accepted press, so a class left on <html> by a page restored from the back/forward cache cannot lock the button. */
  function magicUp(b) {
    if (Date.now() - buyPressAt > 20000) return false;
    return doc.documentElement.classList.contains('razorpay-magic-scroll') || !!(b && b.querySelector('#magic-razorpay-spinner'));
  }
  function cancelBuyPress() {
    buyToken++;
    if (buyWaiting) { buyWaiting = false; setBuyBusy(false); }
  }
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cv-buynow]') : null;
    if (!b) return;
    function stop() { stopClick(e); if (buyRelease) setBuyBusy(false); }
    if (b.disabled || b.getAttribute('aria-disabled') === 'true') { stop(); return; }
    /* a second trusted tap while the first is still opening Magic: swallowed (see the note above). An untrusted press while busy is Magic's own fault path: let it reach the fallback */
    if (!buyRelease && e.isTrusted && (b.classList.contains('is-busy') || Date.now() - buyPressAt < 1500 || magicUp(b))) { stop(); return; }
    var st = buttonState();
    if (st === 'soldout' || st === 'unavailable') { stop(); paintBuyNow(); return; }
    if (!confirmed()) { stop(); track('buy_now_click', { state: 'no_size' }); window.cvSizeError(); return; }
    if (!buyRelease && addNotReady()) {
      stopClick(e);
      if (!buyWaiting) {
        var tok = ++buyToken;
        buyWaiting = true;
        setBuyBusy(true);
        whenAddReady(function () {
          if (tok !== buyToken) return;   /* cancelled: the shopper picked something else after pressing */
          buyWaiting = false; buyRelease = true; try { b.click(); } finally { buyRelease = false; }
        });
      }
      return;
    }
    if (typeof window.cvTeeSwap === 'function') window.cvTeeSwap();   /* Style = Tee: input[name=id] must hold the shadow tee variant before Magic reads the form */
    track('buy_now_click', { state: 'ok' });
    buyPressAt = Date.now();
    setBuyBusy(true);
  }, true);
  /* Magic did not take the click */
  function buyFallback(trusted) {
    track('buy_now_fallback', { trusted: trusted ? 'yes' : 'no' });
    function addThenBag() {
      if (addNotReady()) { setBuyBusy(false); return; }   /* Dawn would ignore the submit: do not arm the redirect */
      buyGoCart = true; buyArming = true;
      try {
        if (typeof window.cvAdd !== 'function' || window.cvAdd('buynow') === false) { buyGoCart = false; setBuyBusy(false); }
      } finally { buyArming = false; }
    }
    /* an untrusted press is Magic's own fault path re-pressing the button after it already put the item in the bag: do not add it twice */
    if (!trusted && window.fetch) {
      var f = $('form[data-type="add-to-cart-form"]'), idEl = f ? f.querySelector('input[name="id"]') : null, vid = idEl ? String(idEl.value) : '';
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var has = ((c && c.items) || []).some(function (it) { return String(it.variant_id) === vid; });
          if (has) location.href = cartUrl(); else addThenBag();
        })
        .catch(addThenBag);
      return;
    }
    addThenBag();
  }
  doc.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cv-buynow]')) buyFallback(e.isTrusted);
  });
  /* Magic's overlay is up: the button is no longer busy */
  function watchMagic() {
    if (!window.MutationObserver) return;
    var isMagic = function (n) { return n && n.nodeType === 1 && /razorpay|magic/i.test((n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : '')); };
    new MutationObserver(function () {
      var b = buyBtn(); if (!b || !b.classList.contains('is-busy')) return;
      if (/razorpay|magic/i.test(doc.documentElement.className)) setBuyBusy(false);
    }).observe(doc.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (doc.body) new MutationObserver(function (list) {
      var b = buyBtn(); if (!b || !b.classList.contains('is-busy')) return;
      list.forEach(function (m) { for (var i = 0; i < m.addedNodes.length; i++) if (isMagic(m.addedNodes[i])) setBuyBusy(false); });
    }).observe(doc.body, { childList: true });
  }

  /* ---------- button label, sticky bar, chest line ---------- */
  function addButton() { return $('.cv-atc'); }
  function currentPrice() { var p = $('[data-cv-price]'); return p ? money(p.textContent) : ''; }
  function buttonState() {
    var b = addButton();
    if (!b) return confirmed() ? 'add' : 'select';
    var lab = $('.cv-atc__label', b), txt = lab ? lab.textContent : '';
    /* read Dawn's / the server's WORD, not the disabled attribute: Dawn also disables the button for the few hundred ms of every refetch */
    if (/sold out/i.test(txt)) return 'soldout';
    if (/unavail/i.test(txt)) return 'unavailable';
    return confirmed() ? 'add' : 'select';
  }
  var painting = false;
  function paintButton() {
    var b = addButton(); if (!b) return;
    var lab = $('.cv-atc__label', b); if (!lab) return;
    var st = buttonState();
    var text = st === 'unavailable' ? 'Unavailable' : st === 'soldout' ? 'Sold out' : st === 'select' ? 'Select size' : 'Add to cart';
    painting = true;
    if (lab.textContent.trim() !== text) lab.textContent = text;
    b.classList.toggle('is-unset', st === 'select');
    b.classList.toggle('is-off', st === 'soldout' || st === 'unavailable');
    var bp = $('.cv-atc__price', b), pr = currentPrice();
    if (bp && pr && bp.textContent !== pr) bp.textContent = pr;
    painting = false;
  }
  function paintSticky() {
    var el = $('[data-cv-sticky]'); if (!el) return;
    var style = checkedValue('style'), colour = checkedValue('colo'), size = checkedValue('size');
    var lineEl = $('[data-cv-sticky-line]', el);
    if (lineEl && (style || colour)) {
      var parts = [];
      if (style) parts.push(style); else { var cur = lineEl.textContent.split(' · ')[0]; if (cur) parts.push(cur); }
      if (colour) parts.push(colour);
      if (size && confirmed()) parts.push(size);
      var line = parts.join(' · ');
      if (lineEl.textContent !== line) lineEl.textContent = line;
    }
    var priceEl = $('[data-cv-sticky-price]', el), pr = currentPrice();
    var wrap = $('.product-form__error-message-wrapper'), errText = (wrap && !wrap.hidden) ? money($('.product-form__error-message', wrap).textContent) : '';
    if (priceEl) {
      if (errText) { priceEl.textContent = 'That didn’t go through.'; priceEl.classList.add('is-err'); }
      else { priceEl.classList.remove('is-err'); if (pr && priceEl.textContent !== pr) priceEl.textContent = pr; }
    }
    var img = $('[data-cv-sticky-img]', el), first = $('.cvp-slide:not(.cv-hide) img');
    if (img && first) {
      var src = first.currentSrc || first.src;
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.classList.toggle('cv-mult', first.classList.contains('cv-mult'));
      img.classList.toggle('cvp-mock', first.classList.contains('cvp-mock'));
    }
    var sb = $('[data-cv-sticky-add]', el), st = buttonState();
    if (sb) {
      var t = st === 'unavailable' ? 'Unavailable' : st === 'soldout' ? 'Sold out' : st === 'select' ? 'Select size' : 'Add to cart';
      var slab = $('[data-cv-sticky-lab]', sb) || sb;
      if (slab.textContent.trim() !== t) slab.textContent = t;
      if (st === 'soldout' || st === 'unavailable') sb.setAttribute('aria-disabled', 'true'); else sb.removeAttribute('aria-disabled');
      /* the same ADDING and ADDED states as the in-page button, read from it (one source of truth, whichever surface started the add) */
      var main = addButton(), busy = !!(main && main.classList.contains('loading'));
      sb.classList.toggle('is-busy', busy);
      sb.classList.toggle('is-added', !busy && !!(main && main.classList.contains('is-added')));
    }
  }
  function paintFit() {
    var nums = $('[data-cv-fit-nums]'), cm = $('[data-cv-fit-cm]');
    if (!nums || !cm) return;
    var show = false, kind = styleKind();
    if (confirmed() && chartFinal(kind)) {
      var size = checkedValue('size'), tb = chart(kind), heads = chartHeads(tb);
      var rows = $$('tr', tb), row = null;
      for (var i = 0; i < rows.length; i++) { var c0 = rows[i].querySelector('td'); if (c0 && c0.textContent.trim() === size) { row = rows[i]; break; } }
      if (row) {
        var v = $$('td', row).slice(1).map(function (td) { return parseFloat(td.textContent); });
        if (v.length >= 2 && v.length === heads.length && v.every(function (n) { return n > 0; })) {
          nums.textContent = heads.map(function (h, k) { return h + ' ' + v[k] + '"'; }).join(' · ');
          cm.textContent = v.map(function (n) { return Math.round(n * 2.54); }).join(' · ') + ' cm';
          show = true;
        }
      }
    }
    nums.hidden = !show;
    cm.hidden = !show;
  }
  function paintGuideLinks() {
    var ok = chartFinal(styleKind());
    $$('[data-cv-open-sizeguide]').forEach(function (b) { b.hidden = !ok; });
    /* trust line 2 sends the shopper to the guide only where a guide exists */
    $$('[data-cv-guide]').forEach(function (el) { el.hidden = (el.getAttribute('data-cv-guide') === 'yes') !== ok; });
  }
  /* "Hoodie. Colour: Black. Size: M." into the one persistent live region (cv_fitline). The first pass only arms it, so nothing is read out on load. */
  function paintLive() {
    var el = $('[data-cv-pick-live]'); if (!el) return;
    if (!el.hasAttribute('data-armed')) { el.setAttribute('data-armed', ''); return; }
    var st = checkedValue('style'), co = checkedValue('colo'), sz = confirmed() ? checkedValue('size') : '';
    var t = [st, co ? 'Colour: ' + co : '', sz ? 'Size: ' + sz : ''].filter(Boolean).join('. ');
    if (t && el.textContent !== t) el.textContent = t;
  }
  function refreshAll() {
    paintButton();
    paintBuyNow();
    paintSticky();
    paintFit();
    paintGuideLinks();
    paintLive();
    updateSticky();
  }

  /* Dawn writes "Add to cart" / "Sold out" / "Unavailable" into the button's first span after every variant change.
     Repaint at once, in the same microtask, so the shopper never sees Dawn's word. */
  function watchButton() {
    var b = addButton(); if (!b || b.__cvWatched) return;
    b.__cvWatched = true;
    var lab = $('.cv-atc__label', b);
    if (lab && window.MutationObserver) {
      new MutationObserver(function () { if (!painting) { paintButton(); paintBuyNow(); paintSticky(); } }).observe(lab, { childList: true, characterData: true, subtree: true });
    }
    if (window.MutationObserver) {
      /* the request ended: if Dawn never answered with a cart update or its own error text, say so (spec: "That didn't go through. Try again.") */
      new MutationObserver(function () {
        paintSticky();   /* ADDING / ADDED on the sticky bar follow the in-page button's classes */
        if (!b.classList.contains('loading') && pendingAdd) {
          pendingAdd = false;
          var wrap = $('.product-form__error-message-wrapper');
          if (!gotUpdate && wrap && wrap.hidden) {
            var msg = $('.product-form__error-message', wrap);
            if (msg) msg.textContent = 'That didn’t go through. Try again.';
            wrap.hidden = false;
          }
          paintSticky();
          if (buyGoCart && !gotUpdate) { buyGoCart = false; setBuyBusy(false); }   /* the fallback add failed: stay here, Dawn shows its error */
        }
      }).observe(b, { attributes: true, attributeFilter: ['class'] });
      var wrap2 = $('.product-form__error-message-wrapper');
      if (wrap2) new MutationObserver(paintSticky).observe(wrap2, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  /* "Added" for 1.2 s, and the offer tag refreshed from /cart.js */
  var addedTimer = 0;
  function flashAdded() {
    var b = addButton();
    if (b) b.classList.add('is-added');
    paintSticky();            /* the sticky bar mirrors the in-page button (paintSticky reads its classes) */
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () { if (b) b.classList.remove('is-added'); paintSticky(); }, 1200);
  }
  function renderOffer(n) {
    var tag = $('[data-cv-offer]'); if (!tag) return;
    var txt = $('[data-cv-offer-txt]', tag), st = $('[data-cv-offer-state]', tag);
    var word = tag.getAttribute('data-cv-offer-word') || '';
    var line, state = word;
    if (n === 0) line = 'Any 3 tees ₹2,398. Add two more.';
    else if (n === 1) line = '1 tee in your bag. Add this and one more, and all 3 are ₹2,398.';
    else if (n === 2) line = '2 tees in your bag. This one makes 3 for ₹2,398.';
    else { line = n + ' tees in your bag.'; }   /* same line and state word as the shelf tag (cv-collection.js) */
    if (txt && txt.textContent !== line) txt.textContent = line;
    if (st) { st.textContent = state; st.hidden = !state; }
  }
  /* the bag note under Buy now: shown while the bag holds anything, because Buy now empties it first */
  function renderBagNote(count) { var n = $('[data-cv-buynow-note]'); if (n) n.hidden = !(count > 0); }
  function refreshCart() {
    if (!($('[data-cv-offer]') || $('[data-cv-buynow-note]')) || !window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if ($('[data-cv-offer]')) renderOffer(window.cvTeeCount(c)); renderBagNote(+(c && c.item_count) || 0); })
      .catch(function () { /* the tag and the note keep what the server rendered */ });
  }

  /* ---------- sheets: window.cvSheet (cv-core.js) when present, else a minimal fallback ---------- */
  var fbStack = [], ignorePop = 0;
  function fbOpen(d, trigger) {
    if (d.open) return;
    d.__cvTrigger = trigger || doc.activeElement;
    d.classList.add('cvp-fb');
    if (d.showModal) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } } else d.setAttribute('open', '');
    doc.documentElement.classList.add('cvp-lock');
    requestAnimationFrame(function () { d.classList.add('is-in'); });
    try { history.pushState({ cvpSheet: d.id }, ''); d.__cvHist = true; } catch (e) { d.__cvHist = false; }
    fbStack.push(d);
    d.dispatchEvent(new CustomEvent('cv:sheet-open', { bubbles: true, detail: { id: d.id } }));
  }
  function fbFinish(d) {
    var k = fbStack.indexOf(d); if (k > -1) fbStack.splice(k, 1);
    d.classList.remove('is-in');
    setTimeout(function () {
      if (d.open && d.close) d.close(); else d.removeAttribute('open');
      if (!fbStack.length) doc.documentElement.classList.remove('cvp-lock');
      var tr = d.__cvTrigger; if (tr && tr.focus) { try { tr.focus(); } catch (e) { /* gone */ } }
      d.dispatchEvent(new CustomEvent('cv:sheet-close', { bubbles: true, detail: { id: d.id } }));
    }, reduced() ? 0 : 280);
  }
  function fbClose(d) {
    if (!d.open || fbStack.indexOf(d) < 0) return;
    if (d.__cvHist) {
      d.__cvHist = false;
      var href = location.href;
      ignorePop++;
      history.back();
      /* Dawn replaces the URL (?variant=) while a sheet is open; the entry we return to has an older one, so put the current one back */
      setTimeout(function () { try { if (location.href !== href) history.replaceState(history.state, '', href); } catch (e) { /* ok */ } }, 80);
    }
    fbFinish(d);
  }
  window.addEventListener('popstate', function () {
    if (window.cvSheet && typeof window.cvSheet.open === 'function') return;
    if (ignorePop) { ignorePop--; return; }
    var d = fbStack[fbStack.length - 1];
    if (d) { d.__cvHist = false; fbFinish(d); }
  });
  doc.addEventListener('cancel', function (e) {
    var d = e.target;
    if (d && d.classList && d.classList.contains('cvp-fb')) { e.preventDefault(); fbClose(d); }
  }, true);

  function sheetOpen(d, trigger) {
    if (!d) return;
    if (window.cvSheet && typeof window.cvSheet.open === 'function') window.cvSheet.open(d, { trigger: trigger });
    else fbOpen(d, trigger);
  }
  function sheetClose(d) {
    if (!d) return;
    if (window.cvSheet && typeof window.cvSheet.close === 'function') window.cvSheet.close(d);
    else fbClose(d);
  }
  function afterClose(d, cb) {
    var done = false;
    function fin() { if (done) return; done = true; d.removeEventListener('cv:sheet-close', fin); cb(); }
    d.addEventListener('cv:sheet-close', fin);
    sheetClose(d);
    setTimeout(fin, 700);
  }
  doc.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-cvp-close]');
    if (x) { var d = x.closest('dialog'); if (d) { e.preventDefault(); sheetClose(d); } return; }
    /* a tap on the dim area of the fallback dialog */
    if (e.target && e.target.classList && e.target.classList.contains('cvp-fb') && e.target.tagName === 'DIALOG') sheetClose(e.target);
  });
  ['cv:sheet-open', 'cv:sheet-close'].forEach(function (n) { doc.addEventListener(n, function () { setTimeout(updateSticky, 0); }); });

  /* Dawn replaces history.state with {} every time it updates ?variant= in the address bar. While a sheet is open that would wipe the
     entry the sheet pushed (so Back could not close it cleanly and an orphan entry would stay behind). So the address bar is frozen
     (Dawn honours data-update-url="false") while the size sheet is open, and brought up to date once the sheet has closed. */
  function syncUrl() {
    try {
      var node = $('variant-selects [data-selected-variant]'); if (!node) return;
      var v = JSON.parse(node.textContent); if (!v || !v.id) return;
      var u = new URL(location.href);
      if (u.searchParams.get('variant') === String(v.id)) return;
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* the address bar is cosmetic */ }
  }
  function holdUrl(d) {
    var i = info(); if (!i || i.getAttribute('data-update-url') !== 'true') return;
    i.setAttribute('data-update-url', 'false');
    var done = function () { d.removeEventListener('cv:sheet-close', done); i.setAttribute('data-update-url', 'true'); syncUrl(); };
    d.addEventListener('cv:sheet-close', done);
  }

  /* ---------- size sheet ---------- */
  /* fixed size order (spec 3.8), whatever order the variants come in: tee-only designs list XS last in the store data */
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
  function sizeRank(v) { var k = SIZE_ORDER.indexOf(String(v || '').toUpperCase()); return k < 0 ? 99 : k; }
  function sizeInputs() {
    return $$('variant-selects .cv-size input[type="radio"]').filter(function (i) { return !i.classList.contains('cv-na'); })
      .sort(function (a, b) { return sizeRank(a.value) - sizeRank(b.value); });
  }
  function openSizeSheet(trigger) {
    var d = $('#cvp-size-sheet'); if (!d) return;
    var box = $('[data-cvp-sizes]', d); if (!box) return;
    box.textContent = '';
    var cur = confirmed() ? checkedValue('size') : null;
    sizeInputs().forEach(function (inp) {
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'cvp-sz' + (inp.value === cur ? ' is-sel' : '');
      b.setAttribute('data-size', inp.value);
      b.setAttribute('aria-pressed', inp.value === cur ? 'true' : 'false');
      if (inp.classList.contains('disabled')) b.setAttribute('aria-disabled', 'true');
      b.textContent = inp.value;
      box.appendChild(b);
    });
    var sub = $('[data-cvp-size-sub]', d);
    if (sub) {
      var st = checkedValue('style'), co = checkedValue('colo'), pr = currentPrice();
      sub.textContent = [st, co, pr].filter(Boolean).join(' · ');
    }
    paintGuideLinks();
    holdUrl(d);
    sheetOpen(d, trigger);
    track('size_sheet_open');
  }
  /* waits for Dawn's refresh after a programmatic size change (price, availability and the hidden variant id all update there) */
  function whenVariantRefreshed(cb) {
    var done = false, un = null;
    function fin() { if (done) return; done = true; try { if (un) un(); } catch (e) { /* ok */ } cb(); }
    if (pubsubReady()) un = subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(fin, 0); });
    setTimeout(fin, 4000);
  }
  function chooseSizeInSheet(val) {
    var d = $('#cvp-size-sheet');
    var inp = sizeInputs().filter(function (i) { return i.value === val; })[0];
    if (!inp) return;
    sizeTapped('sheet');
    var go = function () {
      afterClose(d, function () {
        var st = buttonState();
        if (st === 'soldout' || st === 'unavailable') { refreshAll(); return; }   /* the button already says why */
        if (typeof window.cvAdd === 'function') window.cvAdd('sheet');
      });
    };
    if (inp.checked) { go(); return; }
    whenVariantRefreshed(go);
    inp.checked = true;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }
  doc.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.cvp-sz');
    if (chip && chip.closest('#cvp-size-sheet')) { e.preventDefault(); chooseSizeInSheet(chip.getAttribute('data-size')); }
  });

  /* ---------- size guide sheet (the chart of the selected Style, only while that chart is final, gate G4) ---------- */
  function openGuide(trigger) {
    var kind = styleKind(), d = $('#cvp-guide-sheet'), tb = chart(kind);
    if (!d || !tb || !chartFinal(kind)) return;
    var holder = $('[data-cvp-guide-table]', d); if (!holder) return;
    var sel = confirmed() ? checkedValue('size') : null;
    var heads = ['Size'].concat(chartHeads(tb));
    var table = doc.createElement('table'); table.className = 'cvp-sgt';
    var head = doc.createElement('thead'), hr = doc.createElement('tr');
    heads.forEach(function (h) { var th = doc.createElement('th'); th.scope = 'col'; th.textContent = h; hr.appendChild(th); });
    head.appendChild(hr); table.appendChild(head);
    var body = doc.createElement('tbody');
    $$('tr', tb).forEach(function (r) {
      var cells = $$('td', r); if (cells.length < heads.length) return;
      var tr = doc.createElement('tr');
      if (cells[0].textContent.trim() === sel) tr.className = 'is-sel';
      var c0 = doc.createElement('td'); c0.textContent = cells[0].textContent.trim(); tr.appendChild(c0);
      cells.slice(1, heads.length).forEach(function (c) {
        var n = parseFloat(c.textContent), td = doc.createElement('td');
        td.appendChild(doc.createTextNode(n + ' in'));
        td.appendChild(doc.createElement('br'));
        var cmEl = doc.createElement('span'); cmEl.className = 'cvp-sgt__cm'; cmEl.textContent = Math.round(n * 2.54) + ' cm'; td.appendChild(cmEl);
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });
    table.appendChild(body);
    holder.textContent = ''; holder.appendChild(table);
    var sub = $('[data-cvp-guide-sub]', d); if (sub) sub.textContent = kind === 'tee' ? 'Tee' : 'Hoodie and crewneck';
    $$('[data-cvp-measure]', d).forEach(function (el) { el.hidden = el.getAttribute('data-cvp-measure') !== kind; });
    sheetOpen(d, trigger);
    track('size_guide_open', { style: kind });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cv-open-sizeguide]');
    if (b) { e.preventDefault(); openGuide(b); }
  });

  /* ---------- sticky bar: from first paint, hides while the in-page button, the footer, a sheet or a text field is on screen ---------- */
  var btnVis = false, footVis = false, typing = false, observersOn = false;
  function anySheetOpen() {
    if ($('dialog[open]')) return true;
    /* the after-add sheet: Dawn puts "active" on the inner #cart-notification, cv-cart.js puts "cv-open" on the host */
    var cn = $('cart-notification.cv-open, cart-notification.active, cart-notification[open], #cart-notification.active, cart-drawer.active');
    return !!cn;
  }
  function updateSticky() {
    var el = $('[data-cv-sticky]'); if (!el) return;
    var on = isPhone() && !btnVis && !footVis && !typing && !anySheetOpen();
    if (!('IntersectionObserver' in window)) on = isPhone() && !typing && !anySheetOpen();
    if (el.classList.contains('is-on') === on && (el.inert === !on)) return;
    el.classList.toggle('is-on', on);
    try { el.inert = !on; } catch (e) { /* old engine: aria-hidden below covers it */ }
    el.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  function observeSticky() {
    var el = $('[data-cv-sticky]'); if (!el || observersOn) return;
    observersOn = true;
    if ('IntersectionObserver' in window) {
      var buy = $('.product-form__buttons');
      if (buy) new IntersectionObserver(function (es) { btnVis = es[0].isIntersecting; updateSticky(); firstPaintDone(el); }).observe(buy);
      var foot = $('footer, .footer');
      if (foot) new IntersectionObserver(function (es) { footVis = es[0].isIntersecting; updateSticky(); }).observe(foot);
    } else firstPaintDone(el);
    doc.addEventListener('focusin', function (e) {
      var t = e.target;
      typing = !!(t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) && !/^(radio|checkbox|button|submit|reset)$/i.test(t.type || ''));
      updateSticky();
    });
    doc.addEventListener('focusout', function () { typing = false; setTimeout(updateSticky, 0); });
    try { window.matchMedia('(max-width: 749px)').addEventListener('change', updateSticky); } catch (e) { window.addEventListener('resize', updateSticky); }
    var cn = $('cart-notification, cart-drawer');
    if (cn && window.MutationObserver) new MutationObserver(updateSticky).observe(cn, { attributes: true, attributeFilter: ['class', 'open'] });
    var cs = $('#cart-notification');
    if (cs && window.MutationObserver) new MutationObserver(updateSticky).observe(cs, { attributes: true, attributeFilter: ['class'] });
  }
  /* no slide animation for the very first decision (the bar is server-rendered visible; do not animate it away on load) */
  function firstPaintDone(el) { if (!el.hasAttribute('data-ready')) requestAnimationFrame(function () { el.setAttribute('data-ready', ''); }); }

  doc.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-cv-sticky-go]');
    if (go) {
      var t = $('variant-selects .cv-size') || $('variant-selects');
      if (t && t.scrollIntoView) { try { t.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); } catch (er) { t.scrollIntoView(); } }
      return;
    }
    var sb = e.target.closest && e.target.closest('[data-cv-sticky-add]');
    if (!sb) return;
    e.preventDefault();            /* a real submit button: with scripts failed it still submits the form */
    track('sticky_atc_click');
    if (sb.getAttribute('aria-disabled') === 'true' || sb.classList.contains('is-busy')) return;
    if (!confirmed()) { openSizeSheet(sb); return; }
    if (typeof window.cvAdd === 'function') window.cvAdd('sticky');
  });

  /* ---------- wiring ---------- */
  function init() {
    watchButton();
    watchMagic();
    observeSticky();
    refreshAll();
    if (pubsubReady()) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { watchButton(); refreshAll(); });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'product-form') { refreshCart(); return; }   /* the bag changed somewhere else: keep the note in step */
        gotUpdate = true;
        flashAdded();
        refreshCart();
        if (buyGoCart) { buyGoCart = false; location.href = cartUrl(); }   /* Buy now without Magic: add, then the bag */
      });
    }
  }
  doc.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) { setTimeout(refreshAll, 0); setTimeout(refreshAll, 120); }
  });
  doc.addEventListener('product-info:loaded', function () { watchButton(); refreshAll(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { buyGoCart = false; buyPressAt = 0; setBuyBusy(false); refreshAll(); refreshCart(); } });
  if (doc.readyState !== 'loading') init(); else doc.addEventListener('DOMContentLoaded', init);
})();
